import script from "./kmoocPage.vue?vue&type=script&setup=true&lang=js"
export * from "./kmoocPage.vue?vue&type=script&setup=true&lang=js"

import "./kmoocPage.vue?vue&type=style&index=0&id=3d31ddc6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d31ddc6"]])

export default __exports__